import { defineMessages } from 'react-intl';

export default defineMessages({
  tooltip: {
    id: 'app.components.form.color.tooltip',
    defaultMessage: 'Select color',
  },
});
